import { useMediaQuery } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import cn from 'classnames';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { TribeMembershipDetails } from 'src/api/circles';
import styles from './CircleItem.module.scss';

export const CircleItem: FC<{
  item: TribeMembershipDetails;
  selectedCircle: string | null;
  setSelectedCircle: (id: string | null) => void;
  variant?: 'vertical' | 'horizontal';
}> = ({ item, setSelectedCircle, variant = 'vertical' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    setSelectedCircle(item._id);
    navigate(`/circle/${item._id}`);
  };

  const isWideScreen = useMediaQuery('(min-width:550px)');
  const isHorizontal = variant === 'horizontal';
  const avatarSize = isHorizontal ? 40 : isWideScreen ? 28 : 35;

  const getTruncatedTribeName = (name: string) => {
    if (name.length > 15) {
      return `${name.slice(0, 13)}...`;
    }
    return name;
  };

  const formatRole = (role?: string) => {
    if (!role) {
      return '';
    }
    return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
  };

  if (!item.tribe_name) {
    return null;
  }

  const isSelected =
    (location.pathname.startsWith(`/circle/${item._id}`) &&
      (location.pathname === `/circle/${item._id}` ||
        location.pathname.includes(`/circle/${item._id}/`))) ||
    location.pathname === `/edit-circle/${item._id}`;

  return (
    <div
      onClick={handleClick}
      className={cn(styles.container, {
        [styles.horizontal]: isHorizontal,
        [styles.selectedAvatar]: isHorizontal && isSelected,
      })}
      title={item.tribe_name}
    >
      <Avatar
        src={
          item.tribe_avatar_url ? item.tribe_avatar_url : item.leader_avatar_url
        }
        sx={{
          width: avatarSize,
          height: avatarSize,
          flexShrink: 0,
          backgroundColor: '#f1f1f1',
        }}
      >
        {item.tribe_name ? item.tribe_name.charAt(0) : 'C'}
      </Avatar>
      {!isHorizontal && (
        <div className={styles.textWrapper}>
          <div
            className={cn(styles.tribeName, { [styles.selected]: isSelected })}
          >
            {getTruncatedTribeName(item.tribe_name)}
          </div>
          <div
            className={cn(styles.leaderName, { [styles.selected]: isSelected })}
          >
            {formatRole(item.role)}
          </div>
        </div>
      )}
    </div>
  );
};
